import { Outlet } from 'react-router';
import type { TPermissionRouteProps } from '@routes/models/permissionRoute.model';
import type { FC } from 'react';
import styles from './PermissionRoute.module.css';

const PermissionRoute: FC<TPermissionRouteProps> = ({ isPermissionGranted }) => {
  return isPermissionGranted ? (
    <Outlet />
  ) : (
    <div className={styles.permissionRoute}>
      <div className={styles.permissionRouteContainer}>
        <h1>HTTP Error 403 - Forbidden</h1>
        <p>Access Denied - You don&apos;t have permission to access this resource.</p>
      </div>
    </div>
  );
};

export default PermissionRoute;
